import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Chats, Status } from 'src/app/interfaces/chatData';
import { ChatsService } from 'src/app/service/chats.service';
import { LoginService } from 'src/app/service/login.service';
import { MessagesService } from 'src/app/service/messages.service';
@Component({
  selector: 'app-panelsmallscreencompchat',
  templateUrl: './panelsmallscreencompchat.component.html',
  styleUrls: ['./panelsmallscreencompchat.component.scss']
})
export class PanelsmallscreencompchatComponent implements OnInit {
  @Output() smsChat: EventEmitter<any> = new EventEmitter();

  activeTab: number = 0
  chats: Chats[] = [];

  estatus: Status[] = [];
  private idStatus!: number | null;
  private idDispositivo!: number;
  private esOperador: boolean;


  constructor( 
    private chatsService: ChatsService, private messageService: MessagesService,
    private messagesAlerta: MessageService, private loginService: LoginService
  ) {
    this.esOperador = loginService.chatCrmUser.idRol == 3;
    messageService.obtenerChats().subscribe((nuevosChats) => {
      let hayChatsAsignados = false;
      this.chats = nuevosChats;
      this.chats.map(value => {
        const newChatAsigned = value.newChatAsigned
        if (newChatAsigned === true) {
          hayChatsAsignados = true

          if (hayChatsAsignados) {
            this.messagesAlerta.add({ severity: 'success', summary: 'Nuevos Chats Asignados', detail: 'Se le han asignado nuevas conversaciones' });
          }
        }
      })
    });
    messageService.obtenerIdStatus().subscribe((id) => {
      this.idStatus= id;
    });
    messageService.dispositivo$().subscribe((device) => {
      if (device) {
        this.idDispositivo = device.id
        this.getConversations();
      }
    });
  }

  changeSh() {
    this.smsChat.emit(true);
  }

  ngOnInit(): void {
    this.chatsService.obtenerStatus(this.loginService.chatCrmUser.idCustomer).then(data => this.estatus = data.data);
    this.chatsService.getChats('chats').then(data => this.chats = data);
  }

  handleChange(index: number): void {
    let idStatusToSend: number = 0;
  
    if (index !== 0) {
      const estatusSeleccionado = this.estatus[index - 1]; 
      if (estatusSeleccionado) {
        idStatusToSend = estatusSeleccionado.idStatus;
      }
      
    }
  
    this.messageService.establecerEstatus(idStatusToSend);
    this.messageService.setSelectedChat(null);
    this.messageService.infoContacto(null);
    if(index !== 0){
      this.messageService.updateSearchTerm('');
    }
    // let type: string = "chats"
    // if (index == 1) {
    //   type = 'pending'
    // }
    // if (index == 2) {
    //   type = 'mychats'
    // }
    // if (index == 3) {
    //   type = 'resolved'
    // }
    // this.chatsService.getChats(type).then(data => this.chats = data);
  }

  private async getConversations(): Promise<void> {
    if(!this.idDispositivo){
      this.messagesAlerta.add({ severity: 'error', summary: 'Error', detail: 'Primero seleccione un dispositivo' });
      return;
    }
    if (!this.esOperador) {
      const response = await this.messageService.getConversations(this.idDispositivo, this.idStatus);
      this.chats = response.data.result;
    } else {
      const idUser = this.loginService.chatCrmUser.id;
      const response = await this.messageService.getConversations(this.idDispositivo, this.idStatus, idUser);
      this.chats = response.data.result;
    }

    if(this.chats.length == 0){
      this.messagesAlerta.add({ severity: 'info', summary: 'Sin Mensajes', detail: 'No hay mensajes por mostrar' });
    }

    for (const objeto of this.chats) {
      if (objeto.newConversation === true) {
      //  this.messagesAlerta.add({ severity: 'success', summary: 'Nuevos Mensajes', detail: 'Usted tiene nuevos mensajes por contestar' });
        break;
      }
    }
  
    this.messageService.updateIdStatus(this.idStatus);
  }

}
